import { formatWakeLoopCliLine } from "./cli-entry-command";

const SPACE_SUBCOMMAND_HINT_PATTERN = /^wakeloop space ([a-z-]+)(.*)$/u;

export function normalizeHelpfulHintsForView(
  hints: string[],
  effectiveView: "auto" | "human" | "agent"
): string[] {
  return hints.map((hint) => normalizeHelpfulHintForView(hint, effectiveView));
}

function normalizeHelpfulHintForView(
  hint: string,
  effectiveView: "auto" | "human" | "agent"
): string {
  const normalizedHint =
    effectiveView === "agent" ? addExplicitProfileToSpaceHint(hint) : hint;
  return formatWakeLoopCliLine(normalizedHint);
}

function addExplicitProfileToSpaceHint(hint: string): string {
  if (!hint.startsWith("wakeloop space ") || hint.includes("--profile ")) {
    return hint;
  }
  const match = SPACE_SUBCOMMAND_HINT_PATTERN.exec(hint);
  if (!match) {
    return hint;
  }
  const [, subcommand, rest] = match;
  return `wakeloop space ${subcommand} --profile <profile-id>${rest}`;
}
